import IdpParticipation from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
      return [key, `${val}`];  // stringify
    default:
      return [key, val];
  }
};

const create = (data) => new IdpParticipation(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/IdpParticipation/create.js